import { load } from '@/util/router-utils.js'

export default [
  {
    path: 'stock',
    redirect: 'stock/ingredients',
    component: load('app/client/farm/stock/Index'),
    children: [
      {
        path: 'ingredients',
        component: load('app/client/farm/stock/ingredients/Index')
      },
      {
        path: 'fodder',
        component: load('app/client/farm/stock/fodder/Index'),
        children: [
          { path: 'create', component: load('app/client/farm/stock/fodder/Index') },
          { path: ':fodder_id/recipe/create', component: load('app/client/farm/stock/fodder/Index') },
          { path: ':fodder_id/recipe/edit', component: load('app/client/farm/stock/fodder/Index') },
          { path: ':fodder_id/craft', component: load('app/client/farm/stock/fodder/Index') }
        ]
      },
      {
        path: 'deliveries',
        component: load('app/client/farm/stock/deliveries/Index')
      },
      {
        path: 'companies',
        component: load('app/client/farm/stock/companies/Index')
      }
    ]
  }
]
